import { render, staticRenderFns } from "./PhotosView.vue?vue&type=template&id=95033010&scoped=true&"
import script from "./PhotosView.vue?vue&type=script&lang=js&"
export * from "./PhotosView.vue?vue&type=script&lang=js&"
import style0 from "./PhotosView.vue?vue&type=style&index=0&id=95033010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95033010",
  null
  
)

export default component.exports